module.exports = __webpack_public_path__ + "static/media/button.play.25939706.svg";